import CountryComponent from './country'

export const Country = CountryComponent



// WEBPACK FOOTER //
// ./src/SPRINTA/molecules/Forms/index.js